module.exports = __webpack_public_path__ + "first-50_watermark.jpg?eed856ca9dbc124f7c1a7b184a61bf91";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-50_watermark.jpg
// module id = 579
// module chunks = 0